import { getConfiguration } from '@chr/common-web-ui-configuration';
import { AppConfig } from './react-app-env';
import { datadogRum } from '@datadog/browser-rum';

export const index: Promise<void> = (async () => {
  const config: AppConfig = await getConfiguration();

  try {
    const environment = config.environment;
    if (environment && environment !== 'local') {
      datadogRum.init({
        applicationId: 'bc160d93-5b4f-44bd-9453-3e18dd993681',
        clientToken: 'pub1a40b2d850bedeeddbd83c9106359cfe',
        site: 'us3.datadoghq.com',
        service: 'Online.POExceptions.UI',
        env: environment,
        version: '1.0.0',
        sampleRate: 50,
        premiumSampleRate: 10,
        trackInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        useSecureSessionCookie: true,
        allowedTracingOrigins: [/https:\/\/.*\.chrobinson\.com/],
        beforeSend: event => {
            event.view.url = event.view.url.toLowerCase().replace('#/', '');
          }
      })
  }
  } catch {
    // Do not block loading for a datadog error
  }

  datadogRum.startSessionReplayRecording();
  const { bootstrap } = await import('./bootstrap');
  bootstrap(config);

})();
